
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/my-playlists",
      function () {
        return require("private-next-pages/d/my-playlists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/my-playlists"])
      });
    }
  